<div class="modal-wrapper">
  <!-- Backdrop -->
  <div class="modal-backdrop fade show" (click)="onBackdropClick()"></div>

  <div
    class="modal show d-block modal-right"
    [@slideInRight]="isClosing ? 'void' : '*'"
    id="seeBreakdownModal"
    #detailsModal
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalTitle"
    aria-modal="true"
  >
    <div class="modal-dialog modal-dialog-right" role="document">
      <div class="modal-content modal-details">
        <!-- Summary Header -->
        <div class="summary-header">
          <div class="summary-number">
            {{ totalCount | number }}
          </div>
          <div id="modalTitle" class="summary-title">
            {{ mainTitle | translate }}
          </div>

          <!-- Horizontal bar -->
          <div class="d-flex align-items-center mb-3">
            <div
              class="flex-grow-1 progress rounded-pill bg-light"
              style="height: 22px"
            >
              <div
                *ngFor="let category of categories"
                class="progress-bar"
                role="progressbar"
                [style.width.%]="getCategoryShare(category)"
                [style.backgroundColor]="category.color"
              ></div>
            </div>
          </div>

          <!-- Legend -->
          <div
            *ngFor="let category of categories; let i = index"
            class="d-flex justify-content-between mb-2 px-1 align-items-center"
          >
            <div class="legend d-flex align-items-center">
              <span
                class="dot"
                [ngStyle]="{ backgroundColor: category.color }"
              ></span>
              <span class="label ms-1">{{ !isNetworkStructure ? (category.name | translate) : (categoresFullNames[i] | translate)}}</span>
              <strong class="number ms-2">{{ category.count | number }}</strong>
            </div>
            <div>
              <strong class="number"
                >{{ getCategoryShare(category) | number : "1.0-1" }}%</strong
              >
            </div>
          </div>
        </div>

        <!-- Breakdown -->
        <div class="scrollable-body">
          <div class="breakdown-section mt-2">
            <h6 class="breakdown">{{ "COMMON.BREAKDOWN" | translate }}</h6>

            <div *ngFor="let card of breakdownData">
              <lib-donut-card [data]="card"></lib-donut-card>
            </div>
          </div>
        </div>

        <hr />

        <button type="button" class="btn btn-primary" (click)="onCloseClick()">
          {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
